var viewer_rtlignore_default = {
  "gallery_container": "LaSRh",
  "imageTitleContainer": "_5mrzR",
  "clickableItem": "iazqZ",
  "prerender": "_5w6lG",
  "expandButton": "EjSQ7",
  "itemContainer": "NF7el",
  "expandIcon": "uKKOo",
  "itemOverlay": "pkT7b",
  "imageTitle": "ah9ZS",
  "pointer": "_6Ibay",
  "fadeIn": "Cc6a8",
  "changing_background": "GF2xL"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
